<template>
    <div id="timeline-point-hotspot" class="timeline-point-hotspot">
        <div class="point-hotspot"
             v-for="(hotspot, index) in hotspots"
             :key="index" :style="calculatePositionPoint(hotspot)">
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS & EMITS

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const hotspots = computed(() => {
    return store.getHotspotsData;
});

const video = computed(() => {
    return store.getVideoData;
});

// METHODS
const calculatePositionPoint = (hotspot) => {
    let positionPoint = ((hotspot.timeStart * 100) / video.value.duration);
    if (positionPoint > 100) {
        positionPoint = 99.8;
    }
    return 'left: ' + positionPoint.toFixed(6) + '%;';
};

// LIFECYCLE HOOKS
</script>
